var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4022_22391)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0205 6.22031L8.80022 9.44062V0.75C8.80022 0.3375 8.46272 0 8.05022 0C7.63772 0 7.30022 0.3375 7.30022 0.75V9.44062L4.07991 6.22031C3.78694 5.92734 3.3121 5.92734 3.0196 6.22031C2.7271 6.51328 2.72663 6.98813 3.0196 7.28063L7.5196 11.7806C7.66585 11.925 7.85804 12 8.05022 12C8.24241 12 8.43404 11.9268 8.58038 11.7803L13.0804 7.28025C13.3733 6.98728 13.3733 6.51244 13.0804 6.21994C12.7874 5.92744 12.3112 5.925 12.0205 6.22031Z",
    fill: "#354740"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 12.25V10.75C16 10.3354 15.6646 10 15.25 10C14.8354 10 14.5 10.3375 14.5 10.75V12.25C14.5 13.4908 13.4908 14.5 12.25 14.5H3.75C2.50922 14.5 1.5 13.4922 1.5 12.25V10.75C1.5 10.3375 1.16438 10 0.75 10C0.335625 10 0 10.3375 0 10.75V12.25C0 14.3172 1.68187 16 3.75 16H12.25C14.3172 16 16 14.3172 16 12.25Z",
    fill: "#354740"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4022_22391"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.3a210d2ac9e42a17d22b7b78f4b5cd47.svg";
export { ForwardRef as ReactComponent };